import { styled } from '@mui/system';

export const StyledOutOfNetwork = styled('div')({
    border: '0.5px solid grey',
    borderRadius: '8px',
    display: 'block',
    backgroundColor: '#fff',
    letterSpacing: '.1px',
    marginBottom: '15px',
    h3: {
        fontSize: '1.5rem',
        fontFamily: 'brandon-bold,sans-serif',
    },
    p: {
        fontSize: '1.2rem',
    },
});

export const StyledCard = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        '&': {
            borderBottom: 'none',
        },
    },
    [theme.breakpoints.down('sm')]: {
        paddingTop: '0px',
        '& .innerCard': {
            borderBottom: '1px solid #9E9E9E',
        },
    },
}));

export const TitleContainer = styled('div')({
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
});
